export function getTriggerElementsFromElement(
	element: Element,
	targetAttribute = 'data-target'
) {
	return Array.from(
		document.querySelectorAll<HTMLElement>(
			`[href="#${element.id}"], [${targetAttribute}="#${element.id}"]`
		)
	);
}
